import React, { useEffect } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import SignUpPage from 'containers/pages/SignupPage/SignupPage';
import LoginPage from 'containers/pages/LoginPage/LoginPage';
import SSOLoginPage from 'containers/pages/SSOLoginPage/SSOLoginPage';
import ResetPasswordPage from 'containers/pages/ResetPasswordPage/ResetPasswordPage';
import ForgotPasswordPage from 'containers/pages/ForgotPasswordPage/ForgotPasswordPage';
import { LaunchDarklyStatuses } from 'constants/LaunchDarklyStatuses';
import SignupInvitedPage from 'containers/pages/SignupInvitedPage/SignupInvitedPage';
import VerifyUserEmail from 'containers/pages/VerifyUserEmail/VerifyUserEmail';

const { INITIALIZING } = LaunchDarklyStatuses;

const BackgroundStyle = createGlobalStyle`
  body {
    background: linear-gradient(180deg, #0095FF 0%, #0077CC 100%) fixed;
  }
`;

const NewApp = () => {

  return (
    <>
      <BackgroundStyle />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/login/sso" component={SSOLoginPage} />
      <Route
        path="/login/sso/invalid"
        render={(props) => (
          <SSOLoginPage
            {...props}
            hasError={true}
            errorMessage={{
              title: 'Invalid SSO Domain',
              content:
                "Oops, we don't seem to have SSO configured for that domain",
            }}
          />
        )}
      />
      <Route
        path="/login/sso/need-invite"
        render={(props) => (
          <SSOLoginPage
            {...props}
            hasError={true}
            errorMessage={{
              title: 'Cannot find email address',
              content:
                'We were unable to find a Shoflo user account that matches your email. Please check with your Team Admin to confirm your email address has been invited.',
            }}
          />
        )}
      />
      <Route
        path="/login/sso/error"
        render={(props) => (
          <SSOLoginPage
            {...props}
            hasError={true}
            errorMessage={{
              title: 'Something went wrong',
              content:
                'Oops! Something unexpected happened during your login attempt. Please contact Shoflo support.',
            }}
          />
        )}
      />
      <Route exact path="/signup" component={SignUpPage} />
      <Route
        exact
        path="/signup/invited/:token"
        component={SignupInvitedPage}
      />
      <Route exact path="/reset/:token?" component={ResetPasswordPage} />
      <Route exact path="/forgot" component={ForgotPasswordPage} />
      <Route exact path="/verify/:token" component={VerifyUserEmail} />
    </>
  );
};

const App = ({ launchDarklyStatus }) => {
  if (launchDarklyStatus === INITIALIZING) return null;
  return <NewApp />;
};

export default withRouter(
  connect(({ launchDarklyStatus }) => ({ launchDarklyStatus }), {})(App),
);
